<basetile-renderer #mdFreedataTileRenderer>
  <div target="title">
    <wiz-hgroup width="100%" height="100%" padding="2px" [verticalAlign]="'center'">
      <wiz-image #imgFd [sourceObservable]="data.iconOrDie" tabindex="0" height="30px" width="30px"></wiz-image>
      <wiz-vgroup gap=-3 width="100%">
        <wiz-label
        class="componentLabel"
        [wizLabel]="data.trsLabel"
        [wizTooltip]="data.trsLabel"
        [wizTextBehavior]="'truncate'" ></wiz-label>
        <wiz-hgroup width="100%">
          <wiz-label width="100%" class="smallFont" [wizLabel]="data.childrenCountLabel" ></wiz-label>
          <wiz-icon *ngIf="isMultiLevel"
                    style="font-size: 14px !important;" [wizTooltip]="'$.freedata.multilevel.$'">view-treemap</wiz-icon>
          <wiz-icon *ngIf="isFormula"
          style="font-size: 14px !important;" [wizTooltip]="'$.freedata.kindmeasure.$'">formula</wiz-icon>
          <wiz-icon *ngIf="isWild"
          style="font-size: 14px !important;" [wizTooltip]="'$.freedata.kindwild.$'">wizeoo</wiz-icon>
        </wiz-hgroup>
      </wiz-vgroup>

      <!-- <wiz-label [wizLabel]="data.shortCode" [wizTextBehavior]="'truncate'"></wiz-label> -->
    </wiz-hgroup>
  </div>
  <!-- <div target="actionButtons">
    <wiz-hgroup height="100%" padding="2px" [verticalAlign]="'center'" [horizontalAlign]="'end'">
      <wiz-icon #titleActionButton (click)="onDuplicate($event)" [wizTooltip]="'$.common.clone.$'">duplicate</wiz-icon>
    </wiz-hgroup>
  </div> -->
  <div target="body">
    <wiz-vgroup width="100%" height="100%">
      <wiz-label
        class="componentLabel"
        [wizLabel]="data.trsLabel"
        [wizTextBehavior]="'wordWrap'"
        [wizNbLine]="2"
      ></wiz-label>
      <wiz-label [wizLabel]="elements" [wizTextBehavior]="'wordWrap'" [wizNbLine]="4"> </wiz-label>
    </wiz-vgroup>
  </div>
</basetile-renderer>
